import {
  ComposedChart, Bar, Line, Area, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell
} from 'recharts';

function TransactionChart({ transactions }) {
  // Group transactions by month
  const grouped = {};

  transactions.forEach(t => {
    const date = new Date(t.date);
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    if (!grouped[key]) grouped[key] = { month: key, income: 0, expense: 0 };

    const amount = Number(t.amount);
    if (t.type === 'income') grouped[key].income += amount;
    if (t.type === 'expense') grouped[key].expense += Math.abs(amount);
  });

  const data = Object.values(grouped)
    .sort((a, b) => a.month.localeCompare(b.month))
    .map(d => ({
      ...d,
      net: d.income - d.expense,
      month: new Date(d.month + '-01').toLocaleDateString('en-AU', { month: 'short', year: '2-digit' })
    }));

  const cumulativeData = data.reduce((acc, month, i) => {
    const prev = i === 0 ? 0 : acc[i - 1].cumulative;
    acc.push({ ...month, cumulative: prev + month.net });
    return acc;
    }, []);
  
  const fmt = (v) => `$${Math.abs(v).toLocaleString('en-AU', { minimumFractionDigits: 0 })}`;

  if (data.length === 0) return null;

  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      padding: '24px',
      marginBottom: '28px'
    }}>
      <div style={{
        fontFamily: 'DM Mono, monospace',
        fontSize: '11px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        color: 'var(--muted)',
        marginBottom: '20px'
      }}>
        Income &amp; Expenses Over Time
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e8e6e1" vertical={false} />
          <XAxis
            dataKey="month"
            tick={{ fontFamily: 'DM Mono, monospace', fontSize: 11, fill: '#9b9690' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontFamily: 'DM Mono, monospace', fontSize: 11, fill: '#9b9690' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={fmt}
          />
          <Tooltip
            formatter={(value, name) => [fmt(value), name]}
            contentStyle={{
              fontFamily: 'DM Mono, monospace',
              fontSize: '12px',
              border: '1px solid var(--border)',
              borderRadius: '4px',
              background: 'white'
            }}
          />
          <Legend
            wrapperStyle={{ fontFamily: 'DM Mono, monospace', fontSize: '11px' }}
          />
          <Bar dataKey="income" name="Income" fill="#dcfce7" stroke="#16a34a" strokeWidth={1} radius={[3, 3, 0, 0]} />
          <Bar dataKey="expense" name="Expenses" fill="#fee2e2" stroke="#dc2626" strokeWidth={1} radius={[3, 3, 0, 0]} />
          <Line dataKey="net" name="Net" type="monotone" stroke="#2563eb" strokeWidth={2} dot={{ r: 3, fill: '#2563eb' }} />
        </ComposedChart>
      </ResponsiveContainer>

        <div style={{
            fontFamily: 'DM Mono, monospace',
            fontSize: '11px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: 'var(--muted)',
            margin: '28px 0 20px'
            }}>
            Accumulated Net Over Time
        </div>

        <ResponsiveContainer width="100%" height={200}>
            <ComposedChart data={cumulativeData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e8e6e1" vertical={false} />
                <XAxis
                dataKey="month"
                tick={{ fontFamily: 'DM Mono, monospace', fontSize: 11, fill: '#9b9690' }}
                axisLine={false}
                tickLine={false}
                />
                <YAxis
                tick={{ fontFamily: 'DM Mono, monospace', fontSize: 11, fill: '#9b9690' }}
                axisLine={false}
                tickLine={false}
                tickFormatter={fmt}
                />
                <Tooltip
                formatter={(value) => [fmt(value), 'Cumulative Net']}
                contentStyle={{
                    fontFamily: 'DM Mono, monospace',
                    fontSize: '12px',
                    border: '1px solid var(--border)',
                    borderRadius: '4px',
                    background: 'white'
                }}
                />
                <defs>
                <linearGradient id="netGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#2563eb" stopOpacity={0.15} />
                    <stop offset="95%" stopColor="#2563eb" stopOpacity={0} />
                </linearGradient>
                </defs>
                <Area
                dataKey="cumulative"
                name="Cumulative Net"
                type="monotone"
                stroke="#2563eb"
                strokeWidth={2}
                fill="url(#netGradient)"
                dot={{ r: 3, fill: '#2563eb' }}
                />
            </ComposedChart>
        </ResponsiveContainer>
      </div>
  );
}

export default TransactionChart;